import { AutogenModelWaterfallTender, AutogenRowWaterfallTender } from "./autogen/AutogenModelWaterfallTender";

export class ModelWaterfallTender extends AutogenModelWaterfallTender<RowWaterfallTender> {
    constructor() {
        super(RowWaterfallTender);
    }
}

export class RowWaterfallTender extends AutogenRowWaterfallTender {
}